import { Navigate } from "react-router-dom";
import useAjustes from "./useAjustes";

const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (isAuthenticated === false) {
    return <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />;
  }


  return children;
};

/**
 * Lo contrario de ProtectedRoute: páginas solo para quien no ha iniciado
 * sesión (el login). Con la sesión abierta, entrar a / o a /login mostraba
 * otra vez el formulario de acceso; ahora lleva directo al panel.
 */
export const GuestRoute = ({ isAuthenticated, children }) => {
  if (isAuthenticated === true) {
    return <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} replace />;
  }

  // null: todavía no se sabe si hay sesión (primer render). No se pinta el
  // login para no mostrarlo un instante antes de redirigir.
  if (isAuthenticated === null) return null;

  return children;
};

/**
 * Página que depende de un ajuste de la base (ver useAjustes). Con el ajuste
 * apagado, entrar por la dirección lleva al panel en vez de mostrarla.
 */
export const RequiereAjuste = ({ ajuste, children }) => {
  const ajustes = useAjustes();

  if (ajustes.cargando) return null;

  if (!ajustes[ajuste]) {
    return <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} replace />;
  }

  return children;
};

export default ProtectedRoute;
